import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';


async function getOutEdges(ID) {
    return oxygenUtil.callCommonServiceAPI("graph-search", "getOutEdges",{ID});
}

async function getInEdges(ID) {
    return oxygenUtil.callCommonServiceAPI("graph-search", "getInEdges",{ID});
}

async function getNode(ID) {
    return oxygenUtil.callCommonServiceAPI("graph-search", "getNode",{ID});
}

async function getCompleteGraph(componentId) {
    return oxygenUtil.callCommonServiceAPI("graph-search", "getCompleteGraph",{componentId});
}

export {
    getOutEdges,
    getInEdges,
    getNode,
    getCompleteGraph
};